<span *ngIf="isExhausted(pricing)" style="color: white;background-color: red;padding: 3px;border-radius: 5px;"  id="epuiseg">{{'front_event.exhaused'| translate}}</span>

<span *ngIf="isCominglabel(pricing)" style="color: white;background-color: green;padding: 3px;border-radius: 5px" >{{'front_event.is_comming'| translate}}</span>

<span *ngIf="isClosedlabel(pricing)" style="color: white;background-color: red;padding: 3px;border-radius: 5px" >{{'front_event.is_closed'| translate}}</span>
